// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

const rythm = {
  fontSize: `1rem`,
  lineHeight: 1.4,
  rythm: `1.25rem`, // fontSize * lineHeight
}

export default rythm
